import React from 'react'
import '../assets/css/Product.styl'
function Product() {
        return (
            <div className="product">
               <div className="flex-justify-center box">
                    <div className="flex-column content  flex-justify-center">
                        <img src={require("../assets/images/logo1.png")} alt="" width="118" height="118"/>
                        <div className="fs-40 mt-24">
                        海豚wifi管家
                        </div>
                        <div className="fs-20 mt-24 bold-200">
                        快速增强手机与WIFI发射源之间的信号强度，WiFi网络平均速度及性能可提升一倍以上，做到真正的上网无障碍，蹭网无压力。
                        </div>
                    </div>
                    <div>
                        <img src={require("../assets/images/phone_1.png")} alt="" width="324" height="514"/>
                    </div>
               </div>

               <div className="flex-justify-center box">
                    <div>
                        <img src={require("../assets/images/phone_2.png")} alt="" width="324" height="514"/>
                    </div>
                    <div className="flex-column content-right  flex-justify-center">
                        <img src={require("../assets/images/logo2.png")} alt="" width="118" height="118"/>
                        <div className="fs-40 mt-24">
                        全速手机卫士
                        </div>
                        <div className="fs-20 mt-24 bold-200 ">
                        全速手机卫士是一款便捷的手机管理软件，可以效地解决手机使用过程中卡顿、耗电、内存不足的问题。
                        </div>
                    </div>
               </div>

               <div className="flex-justify-center box">
                    <div className="flex-column content  flex-justify-center">
                        <img src={require("../assets/images/logo3.png")} alt="" width="118" height="118"/>
                        <div className="fs-40 mt-24">
                        WiFi畅联精灵
                        </div>
                        <div className="fs-20 mt-24 bold-200">
                        WiFi畅联精灵，连接优质WiFi，随时随地体验WiFi高速快感，实时检测网络安全，防蹭网，保护信息安全。
                        </div>
                    </div>
                    <div>
                        <img src={require("../assets/images/phone_3.png")} alt="" width="324" height="514"/>
                    </div>
               </div>

               <div className="flex-justify-center box">
                    <div>
                        <img src={require("../assets/images/phone_4.png")} alt="" width="324" height="514"/>
                    </div>
                    <div className="flex-column content-right  flex-justify-center">
                        <img src={require("../assets/images/logo4.png")} alt="" width="118" height="118"/>
                        <div className="fs-40 mt-24">
                        e键连WiFi
                        </div>
                        <div className="fs-20 mt-24 bold-200 ">
                        e键连WiFi是一款专为管理WiFi打造的工具应用，它可以方便的帮助用户进行WiFi的管理，并且丰富的网络功能，如测速、安全体检等能使用户更好的了解当前网络，不再受网络风险的困扰。
                        </div>
                    </div>
               </div>

            </div>
        );
    }
export default Product;